import { PurchaseLicenceRequest } from "@evr/types";

import { apiSso } from "./baseHttp";

export const GetCountries = () => apiSso.get("/sso/countries");

export const GetCurrencies = () => apiSso.get("/sso/currency");

export const AssignTrialLicence = (pendingLicencePurchaseId: string, hash: string, softwareLicenceId: string) => {
  const params = new URLSearchParams({
    pendingLicencePurchaseId,
    hash,
    softwareLicenceId,
  });

  return apiSso.post(
    `/sso/PendingLicencePurchase/AssignTrialLicence?${params.toString()}`,
    null, // no request body
    {
      headers: {
        "X-ClientId": process.env.REACT_APP_CLIENT_ID || "",
      },
    },
  );
};

export const PurchaseSoftwareLicence = (request: PurchaseLicenceRequest) =>
  apiSso.post("/sso/PendingLicencePurchase", request, {
    headers: {
      "X-ClientId": process.env.REACT_APP_CLIENT_ID || "",
    },
  });
